import { PickupModalContainer } from './PickupModalContainer';

export default PickupModalContainer;
